const config = {
  API_BASE: process.env.REACT_APP_API_BASE || 'https://lfbg2tj85b.execute-api.ap-south-1.amazonaws.com',
  COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'ap-south-1_AAm20iWm7',
  COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '6kmis4nfr4c27hv5r5t18ah6lv',
  APP_URL: process.env.REACT_APP_APP_URL || window.location.origin
};

export default config;
